// Temporary migration: coerces the pre-PR-#25150 carriers-filter persisted
// shape ({ id, name, price, value }) into the post-PR shape ({ value }).
// Delete this module — and its import in ./index.ts — once persisted
// session-storage entries have rotated for active users.

import type { CarriersFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/carriers';

const isPlainRecord = (input: unknown): input is Record<string, unknown> =>
  typeof input === 'object' && input !== null && !Array.isArray(input);

const hasBooleanValue = (entry: unknown): entry is { value: boolean } & Record<string, unknown> =>
  isPlainRecord(entry) && typeof entry.value === 'boolean';

export const coerceLegacyCarriersFilterState = (persisted: unknown): CarriersFilterState => {
  if (!isPlainRecord(persisted)) return {};
  const result: CarriersFilterState = {};
  Object.entries(persisted).forEach(([token, entry]) => {
    if (hasBooleanValue(entry)) {
      result[token] = {
        value: entry.value,
        ...(entry.inferred === true && { inferred: true }),
      };
    }
  });
  return result;
};
